import React, { useCallback } from "react";
// forcing rebuild
import ReactDataTable from "./ReactDataTable";
import { MasterGoal } from "./ipmsmodel";
import { useManageIPMSContext } from "./ManageIPMSContex";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const MangageGoalsPage: React.FC = () => {
  const navigate = useNavigate();
  const { listGoalsData, getIpmsGoalsData, removeGoals } = useManageIPMSContext();

  const columns = [
    {
      name: "Id",
      selector: (row: MasterGoal) => row.id,
      sortable: true,
      center: true,
      width: "80px",
    },
    {
      name: "Goals",
      selector: (row: MasterGoal) => (
        <span className=" text-wrap pl-10 block">{row.goal}</span>
      ),
      sortable: true,
      grow: 2,
    },
    {
      name: "Goal Type",
      selector: (row: MasterGoal) => (
        <span className=" text-wrap">{row.goaltype}</span>
      ),
      sortable: true,
      grow: 1,
      center: true,
    },
    {
      name: "Department",
      selector: (row: MasterGoal) => (
        <span className=" text-wrap pl-10 block">{row.department}</span>
      ),
      sortable: true,
      grow: 1,
    },
    {
      name: "Status",
      selector: (row: MasterGoal) => (row.status ? "Active" : "InActive"),
      sortable: true,
      center: true,
      width: "150px",
    },
  ];

  React.useEffect(() => {
    // getAllDepartment({ skip: 0, limit: 50 });
    getIpmsGoalsData();
  }, []);

  const handleEdit = (row: MasterGoal) => {
    if (row) {
      toast.dismiss(); // Dismiss the current toast
      navigate("/ipms_new/manageGoals/update", { state: { item: row, goalTypeOption: listGoalsData?.goal_types } });
    }
  };

  const handleDelete = useCallback(async (row: number) => {
    if (row) {
      await removeGoals(row);
    }
  }, []);

  const confirmDelete = (itemId: MasterGoal) => {
    if (itemId) {
      toast.info(
        <div>
          <p>Are you sure you want to InActive this Goal?</p>
          <div className='mt-2'>
            <button
              className='px-4 py-1  tex-sm bg-blue-600 text-white'
              onClick={() => handleDelete(itemId.id)}
            >
              Yes
            </button>
            <button className='px-4 py-1 mx-2 tex-sm bg-red-500 text-white' onClick={cancelDelete}>
              No
            </button>
          </div>
        </div>,
        {
          autoClose: false,
          closeButton: false,
        },
      );
    }
  };

  const cancelDelete = () => {
    toast.dismiss(); // Dismiss the current toast
  };

  return (
    <div>
      <button
        onClick={() => navigate("/ipms_new/manageGoals/create", { state: { item: null, goalTypeOption: listGoalsData?.goal_types } })}
        className='flex items-center px-4 py-2 text-sm mb-3 bg-gray-900 text-white dark:text-gray-400 rounded-lg focus:outline-none hover:bg-gray-600'
      >
        Add Goals
      </button>
      <ReactDataTable
        columns={columns}
        data={listGoalsData?.master_goals ?? []}
        onEdit={handleEdit}
        showFilter={listGoalsData ? true : false}
        onDelete={confirmDelete}
      />
    </div>
  );
};

export default MangageGoalsPage;
